import { useState } from 'react';

const EXPANDED_STORAGE_KEY = 'aopNotificationExpanded';

const targets = [
    {
        label: 'Pricing',
        value: '2%',
        children: [
            { label: 'Amazon', value: '1.9%' },
            { label: 'Walmart', value: '2.3%' },
            { label: 'Kroger', value: '2%' },
        ],
    },
];

export const AopTargetsNotification = () => {
    // Persist the expand/collapse state so it is preserved across popover
    // re-opens and between the home page card and the bell notifications.
    const [expanded, setExpanded] = useState<boolean>(
        () => localStorage.getItem(EXPANDED_STORAGE_KEY) === 'true',
    );

    const toggleExpanded = (event: React.MouseEvent) => {
        event.stopPropagation();
        setExpanded((prev) => {
            const next = !prev;
            localStorage.setItem(EXPANDED_STORAGE_KEY, String(next));
            return next;
        });
    };

    return (
        <div className="text-sm leading-relaxed">
            <p className="m-0">
                Dave Anderson has shared the Annual Operating Plan. Below are your targets per lever:
            </p>

            {(
                <div className="mt-2">
                    {targets.map((target) => (
                        <div key={target.label}>
                            <p className="m-0 pl-3 font-medium">
                                {target.label} - {target.value}
                            </p>
                            {target.children.map((child) => (
                                <p key={child.label} className="m-0 pl-8">
                                    {child.label} - {child.value}
                                </p>
                            ))}
                        </div>
                    ))}
                </div>
            )}

            <button
                type="button"
                className="mt-1 p-0 bg-transparent border-0 underline cursor-pointer text-inherit"
            >
                {'Click to expand'}
            </button>
        </div>
    );
};
